import CreditsWidget from './CreditsWidget';
import ReadOnlyCreditsWidget from './ReadOnlyCreditsWidget';


export { ReadOnlyCreditsWidget };
export default CreditsWidget;
